import { MyResources } from "myplan";
export default MyResources;
